import { get, getBranchOwner, api, put, post } from "@config"

function url(field) {
    const branch = getBranchOwner().id
    return `${api.products[field]}?branch_owner=${branch}`
}
export function getProductList(payload, filters = []) {
    const branch = getBranchOwner().id
    const url = `${api.products.products}?branch_owner=${branch}`
    const p = products => {
        payload(products)
    }
    get(url, p)
}

export function getProduct(id, payload) {
    const branch = getBranchOwner().id
    const url = `${api.products.products}${id}/?branch_owner=${branch}`
    const p = product => {
        payload(product)
    }
    get(url, p)
}

export function saveProduct(product, payload, errorPayload = err => {},many=false) {
    const branch = getBranchOwner().id
    many = many? `&many=${many}` : ''
    const url = `${api.products.products}?branch_owner=${branch}${many}`
    post(url, product, payload, errorPayload)
}

export function partialUpdate(obj, sellable, payload = () => { }) {
    obj.unit = sellable.unit_branch.id
    obj.price = sellable.price
    obj.name = sellable.name
    delete obj.stock
    if (obj.fiscal_data) {

        obj["fiscal"] = {
            "ncm": obj.fiscal_data.ncm.id,
            "cest": obj.fiscal_data.cest.id,
            "cfop": obj.fiscal_data.cfop.id,
            "template_icms": obj.fiscal_data.template_icms.id
        }
        delete obj.fiscal_data
    }
    const branch = getBranchOwner().id
    const url = `${api.products.products}${obj.id}/?branch_owner=${branch}`
    const p = product => {
        payload(product)
    }
    put(url, obj, p)

}


export function getCategoriesList(payload, filters = []) {
    const branch = getBranchOwner().id
    const url = `${api.products.categories}?branch_owner=${branch} ${filters.length > 0 ? `&${filters.join('&')}` : ''}`

    const p = products => {
        payload(products)
    }
    get(url, p)
}

export function getUnits(payload = () => { }) {
    const branch = getBranchOwner().id
    const url = `${api.products.units}?branch_owner=${branch}`
    const p = units => {
        payload(units)
    }
    get(url, p)
}

export function saveUnit(name, payload) {
    const branch = getBranchOwner().id
    const url = `${api.products.units}?branch_owner=${branch}`
    const p = unit => {
        payload(unit)
    }
    post(url, { name }, p)
}

export function getCategories(payload) {
    const branch = getBranchOwner().id
    const url = `${api.products.categories}?branch_owner=${branch}`
    const p = cagegories => {
        payload(cagegories)
    }
    get(url, p)
}

export function saveCategorie(name, payload, errorPayload = () => {}) {
    const branch = getBranchOwner().id
    const url = `${api.products.categories}?branch_owner=${branch}`
    const p = cagegorie => {
        payload(cagegorie)
    }
    post(url, { name }, p, errorPayload)
}

export function editCategory(id, data, payload, errorPayload = () => {}) {
    const branch = getBranchOwner().id
    const url = `${api.products.categories}${id}/?branch_owner=${branch}`
    const p = cagegorie => {
        payload(cagegorie)
    }
    put(url, data, p, errorPayload)
}



// WEBPACK FOOTER //
// ./src/components/pages/products/utils/index.js